import React from 'react';
import { Box, Container, Text,VStack } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import { Info } from '../components/Info';
import { PUSFComponente } from '../components/PUSFComponente';
import { PUSF_BANNER } from '../Constantes';
import { PUSFlList } from '../components/Listas';

export const PUSFForm: React.FC = () => {

  

return (
<>
   <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={PUSF_BANNER} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Atención a la persona usuaria de Servicios Financieros'} ></Title>
                                <Info infoList={PUSFlList} info={''}></Info>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <PUSFComponente />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>
                        La presente vinculación y/o presolicitud de los productos seleccionados no implica la aceptación del Banco de la Provincia de Buenos Aires. Se encuentra sujeta a análisis por la Unidad de Negocios correspondiente.
                        <br/>
                        <br/>
                        El clic en SÍ ACEPTO importará mi expresa aceptación a todos y cada uno de los Términos y Condiciones indicados precedentemente y la constancia de haber tomado conocimiento y aceptado los <a href='https://www.bancoprovincia.com.ar/CDN/Get/Terminos_y_condiciones_Banco_Provincia'style={{ textDecoration: "none", color:"#3c3c3b", fontWeight: "bold", marginLeft: "2px" }}> Términos y Condiciones para la utilización de Banca Internet Provincia y/o el sitio web del Banco de la Provincia de Buenos Aires</a>; 
                        así como también de haber obtenido toda la información necesaria para utilizar correctamente este medio, los riesgos derivados de su empleo y quien asume los mismos. El click en IMPRIMIR me permite obtener una copia del presente, cuyo texto también se encuentra a mi disposición en <a href='https://www.bancoprovincia.com.ar' style={{ textDecoration: "none", color:"#3c3c3b", fontWeight: "bold", marginLeft: "2px" }}>www.bancoprovincia.com.ar</a>
                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>
   
    
  </>
  );
}